<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title" *ngIf="inner_Evaluate.id==0">فرم ثبت سوال ارزیابی</h5>
      <h5 class="card-title" *ngIf="inner_Evaluate.id>0">فرم ویرایش سوال ارزیابی</h5>
      <form [formGroup]="FormEvaluate" (submit)="SubmitFormEvaluate()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">عنوان</label>
            <textarea formControlName="Title" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">

            </textarea>
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
          </div>
        </div>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing && inner_Evaluate.id==0" type="submit" [disabled]="!FormEvaluate.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
        <button *ngIf="!InProccessing && inner_Evaluate.id>0" type="submit" [disabled]="!FormEvaluate.valid" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-edit"></i> ویرایش اطلاعات </button>

      </form>
  </div>
</div>
